<mat-dialog-content>
  <div class="close-wrapper">
    <button
      mat-icon-button
      type="button"
      (click)="close()"
      [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate"
      data-cy="close">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="text-wrapper">
    <p class="text" *ngIf="!data.confirmationTranslated && !data.confirmationToTranslate">
      {{ 'COMMON.CONFIRMATION.ARE_YOU_SURE' | translate }}
    </p>
    <p class="text" *ngIf="data.confirmationTranslated">
      <span [innerHTML]="data.confirmationTranslated | linebreaks"></span>
    </p>
    <p class="text" *ngIf="data.confirmationToTranslate">
      <span innerHTML="{{ data.confirmationToTranslate | translate: data.translateParams }}"></span>
    </p>
  </div>

  <div class="additional-message-wrapper" *ngIf="data.additionalMessage">
    <mat-form-field appearance="legacy">
      <input data-cy="additional-message" matInput [(ngModel)]="additionalMessage" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons">
    <button mat-raised-button class="cancel-button" (click)="close()">
      {{ (data.noButtonKey ? data.noButtonKey : 'COMMON.ACTION.CANCEL') | translate }}
    </button>
    <button
      mat-raised-button
      class="confirm-button"
      color="primary"
      [disabled]="data.additionalMessage && !additionalMessage.length"
      (click)="save()">
      {{ (data.yesButtonKey ? data.yesButtonKey : 'COMMON.GENERAL.YES') | translate }}
    </button>
  </div>
</mat-dialog-actions>
